import { useState, useEffect } from "react";
import { useLazyQuery, gql } from "@apollo/client";
import { Typography, Skeleton, Grid, Box, Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

import { Container } from "../../../commonStyles";
import MailingStats from "./MailingStats";
import { useSelector } from "react-redux";
import { selectProject } from "../../../features/project/projectSlice";

const AllMailingStats = () => {
  const project = useSelector(selectProject);
  const [mailings, setMailings] = useState([]);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const [filter, setFilter] = useState<string>("all");
  const navigate = useNavigate();

  const [getMailings, { loading }] = useLazyQuery(GETMAILINGS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setMailings(data.getMailingStats.items);
      setCount(data.getMailingStats.count);
    },
    onError: (err) => {
      console.log(err, "err");
    },
  });

  useEffect(() => {
    if (project) {
      getMailings({
        variables: { project: project?._id, page: pageNumber, type: filter, limit: 6 },
      });
    }
  }, [getMailings, pageNumber, project, filter]);

  let array = new Array(6).fill(0);

  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <ArrowBackIcon
          onClick={() => navigate(-1)}
          sx={{ mr: 1, cursor: "pointer", color: "primary.main", alignSelf: "center" }}
          fontSize="small"
        />
        <Typography sx={{ mb: 0, alignSelf: "center" }} variant="h2" component="div" gutterBottom>
          <strong>All Mass Mails</strong>
        </Typography>
      </Box>
      <Box sx={{ display: "flex", mt: 2 }}>
        <FormControl sx={{ width: "400px" }} required>
          <InputLabel id="select-source-type">Filter</InputLabel>
          <Select
            labelId="select-filter"
            id="select-filter"
            name={"filter"}
            label={"Filter"}
            required
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          >
            <MenuItem value={"all"}>All</MenuItem>
            <MenuItem value={"drip"}>Campaign</MenuItem>
          </Select>
        </FormControl>
      </Box>
      {!loading ? (
        mailings.length ? (
          <Box>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {mailings.map((mailing, index) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                    <Container sx={{ height: "100%" }}>
                      <MailingStats mailing={mailing} />
                    </Container>
                  </Grid>
                );
              })}
            </Grid>
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Button disabled={pageNumber === 0} onClick={() => setPageNumber(pageNumber - 1)}>
                {"<"}
              </Button>
              <span>{pageNumber + 1}</span>
              <Button disabled={pageNumber === Math.floor(count / 6)} onClick={() => setPageNumber(pageNumber + 1)}>
                {">"}
              </Button>
            </Box>
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>There are currently no mass mails sent out</Box>
        )
      ) : (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {array.map((number: any, index: number) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                  <Container sx={{ height: "100%" }}>
                    <Skeleton height={40} animation="wave" />
                    <Skeleton height={200} variant="circular" animation="wave" />
                  </Container>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

const GETMAILINGS = gql`
  query getMailingStats($project: MongoID!, $page: Int!, $type: String, $limit: Int!) {
    getMailingStats(project: $project, page: $page, type: $type, limit: $limit) {
      items {
        mailSchedule {
          _id
          emailTemplate {
            subject
          }
          mailDate
        }
        sent
        clicked
        opened
        permanentBounce
        transientBounce
        complaints
        delivered
      }
      count
    }
  }
`;

export default AllMailingStats;
